// src/components/BorealisBadge.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const BorealisBadge = () => {
  return (
    <Link to="/borealis" className="inline-block mt-2 mb-2 decoration-0">
      <div className="flex items-center bg-gradient-to-r from-gray-900 to-blue-900 border border-cyan-400 rounded-full px-3 py-1 shadow-md hover:scale-105 transition-transform cursor-pointer">
        <span className="text-sm mr-2">❄️</span>
        <span className="text-[10px] font-extrabold text-cyan-400 tracking-wider uppercase">
          Borealis Certified
        </span>
      </div>
    </Link>
  );
};

export default BorealisBadge;